<template>
  <section>
    <wrapper-collapse
        :title="row.headerTitle"
        initial-open
        active-class="border-active-content"
        v-for="(row, i) in arrFiltered" :key="i"
    >
      <card-metodics-file :items="row.children"/>
    </wrapper-collapse>
  </section>
</template>

<script>
import {nanoid} from "nanoid"
import WrapperCollapse from "@/components/wrappers/WrapperCollapse";
import CardMetodicsFile from "@/components/cards/cardMetodicsFile";
import {mapGetters} from "vuex";
export default {
  name: "Metodics",
  components: {CardMetodicsFile, WrapperCollapse},
  data() {
    return {
      arr: [
        {
          headerTitle: 'Методические материалы',
          roles: ['ADMIN_ROLE','REGION_ROLE', 'FOUNDER_ROLE'],
          id: nanoid(6),
          children: [
            {
              id: nanoid(6),
              title: `Система прогнозирования потребности в подготовке кадров с высшим образованием и планирование на ее основе общих объемов контрольных цифр приема (Презентация)`,
              link: 'https://files.ined.ru/files/ppk/1_vvodnaya_ppk.pdf',
              name: 'Файл PDF'
            }, {
              id: nanoid(6),
              title: `Методика прогнозирования потребности в подготовке кадров с высшим образованием на основе индикаторов спроса и предложения на выпускников (Презентация)`,
              link: 'https://files.ined.ru/files/ppk/2_indicativnaya_model.pdf',
              name: 'Файл PDF'
            },{
              id: nanoid(6),
              title: `Методика прогнозирования потребности в подготовке педагогических кадров с высшим образованием на основе балансовой модели (Презентация)`,
              link: 'https://files.ined.ru/files/ppk/3_otraslevaya_model_pedagogica.pdf',
              name: 'Файл PDF'
            },{
              id: nanoid(6),
              title: `Методика прогнозирования общих объемов контрольных цифр приема по специальностям и направлениям подготовки высшего образования (Презентация)`,
              link: 'https://files.ined.ru/files/ppk/4_okcp.pdf',
              name: 'Файл PDF'
            },{
              id: nanoid(6),
              title: `Методика прогнозирования потребности в подготовке кадров по УГСН «Образование и педагогические науки»`,
              link: 'https://files.ined.ru/files/ppk/01_bm_44_00_00.pdf',
              name: 'Файл PDF'
            },{
              id: nanoid(6),
              title: `Методика прогнозирования потребности в подготовке кадров с высшим образованием на основе индикаторов, характеризующих спрос и предложение на выпускников организаций, осуществляющих образовательную деятельность по программам высшего образования`,
              link: 'https://files.ined.ru/files/ppk/02_indicativnaya.pdf',
              name: 'Файл PDF'
            },{
              id: nanoid(6),
              title: `Методика планирования общих объемов контрольных цифр приема по специальностям и направлениям подготовки, укрупненным группам специальностей и (или) направлений подготовки высшего образования`,
              link: 'https://files.ined.ru/files/ppk/03_okcp.pdf',
              name: 'Файл PDF'
            },
          ]
        },

      ]
    }
  },
  computed: {
    ...mapGetters('keycloak', {
      getRoles: 'getRoles',
    }),
    arrFiltered() {
      return this.arr.filter(el => {
        let availableRoute = false;
        el.roles.forEach(el2 => {
          if (this.getRoles.includes(el2))
            availableRoute = true
        })
        if (availableRoute) return el
      })
    },
  },
}
</script>

<style scoped>

</style>